import {Vue} from "ui.vue";
import {rest} from "rest.client";

export let CompareList = {
	name: 'CompareList',
	store: BX.Citrus.Vuex.store,
	data: function() {
		return {
			iblock_id: "",
			compare_url: "",
			products: [],
			ajaxPath: "",
			actionCode: "action",
			showTitle: false,
			wrapper: "header__menu--compare"
		};
	},
	computed: {
		loc: () => Object.freeze(Vue.getFilteredPhrases("CATALOG_COMPARE_LIST_")),
		productCount: function () {
			return this.$store.getters['compare/count'];
		}
	},
	created: function() {
		this.$store.dispatch('compare/setData', Object.keys(this.products));
		this.$store.dispatch('compare/setIBlockId', this.iblock_id);

		// Vue.event.$on('Citrus.Vue.Compare:remove', this.refresh);
		// Vue.event.$on('Citrus.Vue.Compare:refresh', this.refresh);
		// Vue.event.$on('Citrus.Vue.Compare:add', this.refresh);

		BX.addCustomEvent('Citrus.Vue.Compare:remove', this.removeProductId);
		// BX.addCustomEvent(window, "OnCompareChange", this.refresh);
		// BX.addCustomEvent("Citrus.Vue.Compare:refresh", this.refresh);

		BX.addCustomEvent("Citrus.Vue.Compare:clean", this.clean);
	},
	beforeDestroy: function () {
		// Vue.event.$off('Citrus.Vue.Compare:remove', this.refresh);
		// Vue.event.$off('Citrus.Vue.Compare:refresh', this.refresh);
		// Vue.event.$off('Citrus.Vue.Compare:add', this.refresh);

		// BX.removeCustomEvent(window, "OnCompareChange", this.refresh);
		// BX.removeCustomEvent("Citrus.Vue.Compare:refresh", this.refresh);

		BX.removeCustomEvent('Citrus.Vue.Compare:remove', this.removeProductId);
		BX.removeCustomEvent("Citrus.Vue.Compare:clean", this.clean);
	},
	methods: {
		removeProductId: function (id)
		{
			this.$store.dispatch('compare/remove', parseInt(id));
		},
		clean:function()
		{
			this.$store.dispatch('compare/clean');
		},
		refresh: function()
		{
			this.loading = true;

			rest.callMethod("citrus.compare.getList", {
					iblock_id: this.iblock_id,
				},
				(response) => {
					this.loading = false;
					if (
						response.answer.hasOwnProperty("error")
						|| !response.answer.hasOwnProperty("result")
						|| !response.answer.result
					) {
						console.info(response.answer);
						return;
					}

					this.count = Object.keys(response.answer.result).length;
					this.arProducts = response.answer.result;
				}
			);
		},
		setProducts: function(products)
		{
			let productIds = Object.keys(products);
			this.count = productIds.length;
			this.arProducts = products;
			this.$store.dispatch('compare/load', productIds);
		},
		add: function(productId)
		{
			if(!productId) {
				return;
			}

			this.loading = true;

			// формирование данных для отправки
			let ajaxFormData = new FormData(),
				data = {
					id: productId,
					sessid: BX.bitrix_sessid(),
					ajax_action: 'Y',
					[this.actionCode]: 'ADD_TO_COMPARE_LIST'
				};

			for (let key in data) {
				ajaxFormData.set(key, data[key]);
			}

			axios({
				method: 'POST',
				url: this.ajaxPath,
				data: ajaxFormData
			}).then(response => {

				console.log(response);

			}).catch((error) => {
				console.error(error);
			}).finally(() => (this.loading = false));
		},
		remove: function(product, id)
		{
			if (!product.ID || !id) {
				return true;
			}

			this.loading = true;
			this.arProducts[id].loading = true;

			// формирование данных для отправки
			let ajaxFormData = new FormData(),
				data = {
					id: product.ID,
					sessid: BX.bitrix_sessid(),
					ajax_action: 'Y',
					[this.actionCode]: 'DELETE_FROM_COMPARE_LIST'
				};

			for (let key in data) {
				ajaxFormData.set(key, data[key]);
			}

			axios({
				method: 'POST',
				url: this.ajaxPath,
				data: ajaxFormData
			}).then((response) => {
				if ('undefined' === response.data) {
					throw new (response);
				}

				if('undefined' !== response.data.OK && 'OK' !== response.data.OK) {
					delete this.arProducts[id];


					this.$store.dispatch('compare/remove', product.ID);
					if(undefined !== this.$store) {
						this.$store.dispatch('compare/remove', product.ID);
					}

					Vue.event.$emit('Citrus.Vue.Product.Compare:remove:' + product.ID);

					// отправим события для Bitrix
					BX.onCustomEvent('onCatalogDeleteCompare', [response.data.ID]);

					console.log(response.data.MESSAGE);
					this.count = response.data.COUNT;
				}
				else {
					throw new (response.data.ID + ': ' + response.data.MESSAGE);
				}

			}).catch((error) => {
				console.error(error);
			}).finally(() => (this.loading = false));
		}
	}
};

export default {CompareList};
